import React from "react";
import PropTypes from "prop-types";

import "./PoonaWallaPageLoader.scss";

const PoonaWallaPageLoader = ({ isLoading }) => {
  return isLoading ? (
    <div className="PoonaWallaPageLoader">
      <div className="PoonaWallaPageLoader__loader"></div>
    </div>
  ) : null;
};

export default PoonaWallaPageLoader;

PoonaWallaPageLoader.propTypes = {
  isLoading: PropTypes.bool,
};
